import React from 'react';
import { MuiTelInput, type MuiTelInputProps } from 'mui-tel-input';
import { ArrowDownIcon } from '@src/shared/ui/icons';

const StyleSheet = {
  root: {
    '.MuiInputAdornment-root': {
      mr: 0,
    },
    '.MuiButtonBase-root': {
      aspectRatio: 'auto',
      ml: '6px',
      p: 0,
      '&:hover': {
        backgroundColor: 'transparent',
      },
    },
    '.MuiTelInput-FlagImg': {
      mr: 0.5,
      width: 'auto',
      height: '18px',
    },
  },
};

const defaultGetFlagElement: MuiTelInputProps['getFlagElement'] = (
  _isoCode,
  { imgProps, isSelected },
) => (
  <>
    <img {...imgProps} alt={imgProps.alt ?? ''} />
    {isSelected && <ArrowDownIcon fontSize="small" sx={{ color: (theme) => `${theme.palette.grey[800]} !important` }} />}
  </>
);

const PhoneInput = React.forwardRef<HTMLDivElement, MuiTelInputProps>(
  ({ sx, ...props }, ref) => {
    const mergedSx = [
      StyleSheet.root,
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ];
    return (
      <MuiTelInput
        ref={ref}
        getFlagElement={defaultGetFlagElement}
        {...props}
        sx={mergedSx}
      />
    );
  },
);

PhoneInput.displayName = 'PhoneInput';
export default PhoneInput;
